import { styled, css } from "styled-components";
import media from "../../../styles/mediaQueries";
export const Wrapper = styled.div `
  padding-left: 259px;
  ${media.down("belowMedium") `
    overflow: hidden;
    max-width: 100%;
    padding-left: 0;
    left: 0;
    ${(props) => props.isSidebarOpen &&
    css `
        position: relative;
      `}
  `}
  ${media.only("medium", "belowLarge") `
      padding-left: ${(props) => props.width ? `${props.width - 1}px` : "199px"};
    `}
  ${media.only("large", "xlarge") `
      padding-left: ${(props) => props.width ? `${props.width - 1}px` : "199px"};
  `}
`;
export const Main = styled.main `
  width: 100%;
  position: relative;

  ${media.down("belowMedium") `
    left: 0;
    transition: left .4s ease-out;
  `}
`;
export const PageContent = styled.div `
  transition: all 0.6s cubic-bezier(0.27, 0.74, 0.32, 1.01);
  right: 0;
  position: relative;
  opacity: 1;
`;
export const MainContainer = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  ${media.down("belowMedium") `
    margin-top: 55px;
  `}
`;
//# sourceMappingURL=style.js.map